const load3kit = (callback?: () => void) => {
  const existingScript = document.getElementById("threekit") as HTMLScriptElement | null;

  if (existingScript) {
    if (existingScript.getAttribute("data-loaded") === "true") {
      // Скрипт уже загружен ранее
      if (callback) callback();
    } else {
      // Скрипт еще загружается — навешиваем слушатель
      existingScript.addEventListener("load", () => {
        if (callback) callback();
      });
    }
    return;
  }

  const script = document.createElement("script");
  script.src = "https://admin-fts.threekit.com/app/js/threekit-player.js";
  script.id = "threekit";
  script.setAttribute("data-loaded", "false");

  script.onload = () => {
    script.setAttribute("data-loaded", "true");
    if (callback) callback();
  };

  document.body.appendChild(script);
};

export function loadThreekitScript(callback?: () => void) {
  const existingScript = document.getElementById("threekit") as HTMLScriptElement | null;

  if (existingScript) {
    if (existingScript.getAttribute("data-loaded") === "true") {
      // Скрипт уже загружен ранее
      if (callback) callback();
    } else {
      // Скрипт еще загружается — навешиваем слушатель
      existingScript.addEventListener("load", () => {
        if (callback) callback();
      });
    }
    return;
  }

  const script = document.createElement("script");
  script.src = "https://admin-fts.threekit.com/app/js/threekit-player.js";
  script.id = "threekit";
  script.setAttribute("data-loaded", "false");

  script.onload = () => {
    script.setAttribute("data-loaded", "true");
    if (callback) callback();
  };

  document.body.appendChild(script);
}

export default load3kit;
